import { Dropdown, Table, Form, Button, InputGroup } from "react-bootstrap";
import { CSVLink } from "react-csv";
import {
  ExportIcon,
  FilterTwoIcon,
  SummaryChartIconUp,
  SummaryCloseIcon,
  FilterCollapseIcon,
  ExcelIcon,
  PDFIcon,
  EditIcon,
} from "../../Icons";
import "../../../assets/scss/reports/cashbook.scss";
import { useEffect, useRef, useState } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import Select from "react-select";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
  useScrollTop,
} from "../../../utils/hooks";
import { useQuery } from "react-query";
import { format, parse } from "date-fns";
import ReactPaginate from "react-paginate";
import {
  defaultSelectValue,
  formatDate,
  paginationOptions,
  reactSelectTheme,
} from "../../../utils/helpers";
import RsDateRangePicker from "../../utils/RsDateRangePicker";
import queryString from "query-string";
import { useAuth } from "../../../hooks/useAuth";
import { isEmpty } from "lodash";
import NoTableItem from "../../utils/NoTableItem";
import { useDownloadExcel } from "../../../hooks/useDownloadExcel";
import ModalLoader from "../../utils/ModalLoader";
import VendorSelector from "../../Vendor/VendorSelector";
import { Popover } from "react-tiny-popover";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Link } from "react-router-dom";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ManageATCModal from "./ManageATCModal";

const statusOptions = [
  { label: "All", value: "" },
  { label: "Not Loaded", value: "Not Loaded" },
  { label: "Partially Loaded", value: "Partially Loaded" },
  { label: "Loaded", value: "Loaded" },
];

export default function AtcStocking() {
  useScrollTop();

  const initialFilterParams = {
    q: "",
    Status: "",
    // startDate: format(new Date(), "yyyy-MM-dd"),
    // endDate: format(new Date(), "yyyy-MM-dd"),
    enableDateRange: true,
    Vendor_ID: "",
  };

  const { backendUrl } = useAuth();

  const [showFilter, setShowFilter] = useLocalStorage("showFilter", true);
  const [btnSummryActive, setBtnSummaryActive] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [showVendorPopover, setShowVendorPopover] = useState(false);
  const [showManageATCModal, setShowManageATCModal] = useState(false);
  const [selectedATCSetup, setSelectedATCSetup] = useState(null);

  const CSVLinkRef = useRef(null);

  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const close = () => {
    setBtnSummaryActive(false);
  };

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams]);

  const fetchStocking = async queryParams => {
    let response = await fetch(
      `${backendUrl}/api/vendors/ledger?${queryString.stringify(queryParams)}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };

  const {
    data = {
      count: 0,
      vendorLedgers: [],
    },
    refetch,
    isSuccess,
    isFetching,
  } = useQuery(
    ["ATC_STOCKING", queryParams],
    () => fetchStocking(queryParams),
    {
      keepPreviousData: true,
    }
  );

  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    let exData = await fetchExcelData(
      `${backendUrl}/api/vendors/ledger?${queryString.stringify(rest)}`,
      "GET"
    );

    const company = exData.data?.company?.CompName;

    exData = (exData.data?.vendorLedgers || []).map(d => [
      d.Post_Date ? format(new Date(d.Post_Date), "MMM dd, yyyy") : "...",
      d.Trans_ID,
      d.vendor?.CompanyName || "",
      d.Qty,
      d.Pickup_Location || "",
      d.Category || "",
      d.PaymentType || "",
    ]);

    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy")}`
        : "";

    exData = [
      [company],
      ["ATC Stocking Report"],
      [date],
      [""],
      [
        "Trans Date",
        "Ticket Number",
        "Vendor",
        "Quantity",
        "Plant / Depot",
        "Product",
        "Payment Type",
      ],
      ...exData,
    ];

    setExcelData(exData);
  };

  const handleFilterParamsChange = e => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSearchQueryChange = e => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const filterByDateRange = date => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };

  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSelectedVendor = vendor => {
    setFilterParams({
      ...filterParams,
      Vendor_ID: vendor.Vendor_ID,
    });
    setShowVendorPopover(false);
  };

  const handleATC = el => {
    setSelectedATCSetup({
      invoiceId: el.Trans_ID,
      invoiceNumber: el.Trans_ID,
      InvoiceNo: el.Trans_ID,
      atcRow: el,
    });
    setShowManageATCModal(true);
  };

  return (
    <main className="cash-book">
      <div className="content">
        <div className="content-main">
          <div className={`filter-area ${showFilter ? "open" : "close"}`}>
            <div className="filter-header">
              <h2>
                <FilterTwoIcon /> Filters
              </h2>
              <Button
                variant="white"
                onClick={() => setShowFilter(!showFilter)}
              >
                <FilterCollapseIcon />
              </Button>
            </div>
            <div className="filter-body">
              <Form>
                <div className="body">
                  <Form.Group className="mb-2-5">
                    <Form.Label>Ticket Number</Form.Label>
                    <Form.Control
                      name="q"
                      placeholder="Search Ticket Number..."
                      value={filterParams.q}
                      onChange={e => handleFilterParamsChange(e)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2-5">
                    <Form.Label>Vendor ID</Form.Label>
                    <InputGroup>
                      <Form.Control
                        name="Vendor_ID"
                        placeholder="Enter Vendor ID"
                        value={filterParams?.Vendor_ID}
                        onChange={() => {}}
                        readOnly
                      />
                      <Popover
                        isOpen={showVendorPopover}
                        onClickOutside={() => setShowVendorPopover(false)}
                        content={() => (
                          <VendorSelector
                            handleSelectedCustomer={handleSelectedVendor}
                            setShowCustomerSelector={setShowVendorPopover}
                          />
                        )}
                        position="bottom"
                      >
                        <InputGroup.Text
                          onClick={() =>
                            setShowVendorPopover(!showVendorPopover)
                          }
                        >
                          <MagnifyIcon />
                        </InputGroup.Text>
                      </Popover>
                    </InputGroup>
                  </Form.Group>

                  {/* <Form.Group className="mb-2-5">
                    <Form.Label>Status</Form.Label>
                    <Select
                      classNamePrefix="form-select"
                      placeholder="All"
                      name="Status"
                      theme={reactSelectTheme}
                      isSearchable={false}
                      onChange={selected => {
                        setFilterParams({
                          ...filterParams,
                          Status: selected.value,
                        });
                      }}
                      defaultValue={defaultSelectValue(
                        queryParams?.Status,
                        statusOptions,
                        { value: "", label: "All" }
                      )}
                      options={statusOptions}
                    />
                  </Form.Group> */}

                  <hr className="mt-1 mb-4" />

                  <Form.Group className="">
                    <Form.Label>Date Range</Form.Label>
                    <div className="position-relative">
                      <RsDateRangePicker
                        placement="auto"
                        value={
                          filterParams.startDate && filterParams.endDate
                            ? [
                                parse(
                                  filterParams.startDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                                parse(
                                  filterParams.endDate,
                                  "yyyy-MM-dd",
                                  new Date()
                                ),
                              ]
                            : []
                        }
                        onClean={() => clearDateRange()}
                        onOk={date => filterByDateRange(date)}
                      />
                    </div>
                  </Form.Group>
                </div>

                <div className="buttons rounded">
                  <Button onClick={() => reset()} variant="white">
                    Reset
                  </Button>
                  <Button onClick={() => search()} variant="primary">
                    Search
                  </Button>
                </div>
              </Form>
            </div>
          </div>

          <div className="content-body">
            <header>
              <h1>
                {!showFilter && (
                  <button
                    onClick={() => setShowFilter(!showFilter)}
                    className="btn filter"
                  >
                    <FilterTwoIcon />
                  </button>
                )}
                ATC Stocking & Mgt.
                <button onClick={() => refetch()} className="btn text-primary">
                  <CachedIcon />
                </button>
              </h1>
              <div className="actions mr-5">
                {/* <Link
                  className="btn btn-outline-primary px-3 d-flex align-items-center"
                  to="/load-atc"
                >
                  Split & Load ATC
                </Link> */}

                <CSVLink
                  className="btn print d-none"
                  filename={`ATC Stocking(${format(
                    new Date(),
                    "dd-MMM-yyyy hh:mm:ss a"
                  )}).csv`}
                  data={excelData}
                  ref={CSVLinkRef}
                />

                <Dropdown>
                  <Dropdown.Toggle
                    variant=""
                    className="btn print"
                    disabled={isfetchingExcel}
                    bsPrefix=""
                  >
                    <ExportIcon color="#008000" />
                    Export
                  </Dropdown.Toggle>
                  <Dropdown.Menu
                    popperConfig={{ strategy: "fixed" }}
                    renderOnMount
                    className="text-center"
                  >
                    <Dropdown.Item
                      as="div"
                      onClick={onDownloadExcelData}
                      className="p-cursor"
                    >
                      Excel <ExcelIcon color="#008000" />
                    </Dropdown.Item>
                    <Dropdown.Item as="div">
                      <a
                        href={`${backendUrl}/api/vendors/ledger/pdf?${queryString.stringify(
                          rest
                        )}`}
                        target="_blank"
                        rel="noreferrer"
                      >
                        PDF <PDFIcon color="#ff0000" />
                      </a>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                {/* <button
                  onClick={() => setBtnSummaryActive(true)}
                  className="btn summaryBtnWhite btn-outline-primary"
                >
                  Show Summary
                </button> */}
              </div>
            </header>

            <div className="px-md-4">
              <Table responsive borderless striped className="product-table">
                <thead>
                  <tr>
                    <th>{"  "}</th>
                    <th>Trans Date</th>
                    <th>Ticket Number</th>
                    <th>Vendor</th>
                    <th>Quantity</th>
                    <th>Region</th>
                    <th>Plant</th>
                    <th>Depot</th>
                    <th>Product</th>
                    <th>Category</th>
                    <th>Payment Type</th>
                    <th>Bank</th>
                    <th>Username</th>
                  </tr>
                </thead>
                <tbody>
                  {data.vendorLedgers.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {"  "}

                        <Dropdown drop="end">
                          <Dropdown.Toggle
                            variant=""
                            className="bg-white border-0"
                            bsPrefix="print more"
                          >
                            <DotsVerticalIcon />
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            popperConfig={{
                              strategy: "fixed",
                            }}
                            renderOnMount
                            className="dropdown-with-icons"
                          >
                            <Dropdown.Item
                              as="button"
                              onClick={() => handleATC(el)}
                            >
                              <EditIcon /> View / Manage ATCs
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                      <td className="text-nowrap">
                        {el.Post_Date
                          ? format(new Date(el.Post_Date), "MMM dd, yyyy")
                          : "..."}
                      </td>
                      <td>{el.Trans_ID}</td>
                      <td>{el.vendor?.CompanyName}</td>
                      <td className="text-nowrap">
                        {el?.loaded} of {el?.Qty} Loaded
                      </td>
                      <td>{el.Region || "_"}</td>
                      <td>{el.Plant || "_"}</td>
                      <td>{el.Depot || "_"}</td>
                      <td>{el.Product_Name || "_"}</td>
                      <td>{el.Cat_Name || "_"}</td>
                      <td>{el.PaymentType}</td>
                      <td>{el.BankName || "_"}</td>
                      <td>{el.Username}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {!isFetching && isSuccess && isEmpty(data?.vendorLedgers) ? (
                <NoTableItem queryParams={queryParams} />
              ) : null}
            </div>

            <div className="d-flex justify-content-between px-3 align-items-center pagination">
              <div className="pagination_left">
                <p className="m-0 p-0">Show</p>
                <select
                  value={queryParams.limit}
                  name="limit"
                  className="form-select"
                  onChange={e => handleSearchQueryChange(e)}
                >
                  <option value="10">10 rows</option>
                  <option value="20">20 rows</option>
                  <option value="30">30 rows</option>
                  <option value="40">40 rows</option>
                  <option value="50">50 rows</option>
                  <option value="100">100 rows</option>
                </select>
              </div>

              <ReactPaginate
                {...paginationOptions}
                pageCount={Math.ceil(data.count / queryParams.limit)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={0}
                onPageChange={({ selected }) => {
                  document.body.scrollTop = document.documentElement.scrollTop = 0;
                  setQueryParams({
                    ...queryParams,
                    page: selected + 1,
                  });
                }}
                forcePage={queryParams.page - 1}
              />
            </div>
          </div>
        </div>
      </div>

      {showManageATCModal && selectedATCSetup ? (
        <ManageATCModal
          show={showManageATCModal}
          onHide={() => setShowManageATCModal(false)}
          selectedATCSetup={{
            ...selectedATCSetup,
            InvoiceNo: selectedATCSetup.Trans_ID,
          }}
          onSave={() => {
            setShowManageATCModal(false);
            refetch();
          }}
        />
      ) : null}

      <ModalLoader show={isfetchingExcel} />
    </main>
  );
}
